import Landing from './components/Landing/Landing';
import {BrowserRouter as Rotuer, Route} from 'react-router-dom';
import "aos/dist/aos.css"
import './App.css';

function App() {
  return (
    <Rotuer>
      <Route path="/" component= {Landing} />
    </Rotuer>
  );
}

export default App;